const DISCOUNT_AUTO_DISMISS_MS = 6000;
const DISCOUNT_SESSION_PREFIX = 'discount-notified:';

class DiscountNotification extends HTMLElement {
  constructor() {
    super();

    this.inner = this.querySelector('.discount-notification__inner');
    this.textEl = this.querySelector('[data-discount-text]');
    this.closeButton = this.querySelector('.discount-notification__close');
    this.dismissTimer = null;

    this.close = this.close.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
  }

  connectedCallback() {
    // Avoid noise while editing the theme.
    if (window.Shopify && window.Shopify.designMode) return;

    const code = this.resolveDiscountCode();
    console.log('FOUND CODE', code);
    if (!code || this.alreadyNotified(code)) {
      console.log('NOT NOTIFYING');
      return;
    }

    this.show(code);
  }

  resolveDiscountCode() {
    // 1. Server-rendered code (reliable when the cart has items).
    const cartCode = (this.dataset.cartDiscount || '').trim();
    if (cartCode) return cartCode;

    // 2. URL discount applied to an empty cart lives in a cookie.
    return this.readCookie('discount_code');
  }

  readCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]).trim() : '';
  }

  alreadyNotified(code) {
    try {
      const key = DISCOUNT_SESSION_PREFIX + code;
      if (sessionStorage.getItem(key)) return true;
      sessionStorage.setItem(key, '1');
    } catch (e) {
      // Private mode / storage disabled: fail open and still greet once per load.
    }
    return false;
  }

  show(code) {
    const template = this.dataset.messageTemplate || '[code]';
    this.textEl.textContent = template.replace('[code]', code);

    this.hidden = false;
    // Force a reflow so the entrance transition runs.
    void this.offsetWidth;
    this.classList.add('is-visible');

    this.closeButton.addEventListener('click', this.close);
    this.addEventListener('keyup', this.onKeyup);

    this.dismissTimer = window.setTimeout(this.close, DISCOUNT_AUTO_DISMISS_MS);
  }

  onKeyup(event) {
    if (event.code === 'Escape') this.close();
  }

  close() {
    if (this.dismissTimer) {
      window.clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }

    this.classList.remove('is-visible');
    this.closeButton.removeEventListener('click', this.close);
    this.removeEventListener('keyup', this.onKeyup);

    this.addEventListener(
      'transitionend',
      () => {
        this.hidden = true;
      },
      { once: true }
    );
  }
}

customElements.define('discount-notification', DiscountNotification);
